import { render } from "./p-select.vue?vue&type=template&id=034003a1&ts=true"
import script from "./p-select.vue?vue&type=script&lang=ts"
export * from "./p-select.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__